import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import validateForm from "./CollectionMethodValidation";
import { useWebServer } from "../../../../../providers";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import { createCollectionMethod } from "../../../../../actions";
import CollectionMethodForm from "./CollectionMethodForm";

const CollectionMethodCreate = ({ createCollectionMethod, ...otherProps }) => {
  const { sendRequest } = useWebServer();
  const history = useHistory();

  const onSave = async (collectionMethod) => {
    await createCollectionMethod(collectionMethod, sendRequest);
    history.push(ROUTES.collectionMethods);
  };

  return <CollectionMethodForm {...otherProps} onSave={onSave} />;
};

const formWrapped = reduxForm({
  form: "CollectionMethodCreate",
  validate: validateForm,
})(CollectionMethodCreate);

export default connect(null, { createCollectionMethod })(formWrapped);
